
import { Phone, Mail } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#333333] text-white py-6 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-sm">© {currentYear} 647.Repair. All rights reserved.</p>
          </div>
          <div className="flex items-center space-x-6">
            <a href="tel:1-800-793-9081" className="flex items-center text-sm hover:text-blue-400">
              <Phone className="h-4 w-4 mr-2" />
              1-800-793-9081
            </a>
            <a href="mailto:info@647.repair" className="flex items-center text-sm hover:text-blue-400">
              <Mail className="h-4 w-4 mr-2" />
              info@647.repair
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
